import { render, staticRenderFns } from "./commdsClass.vue?vue&type=template&id=38c8016e&scoped=true"
import script from "./commdsClass.vue?vue&type=script&lang=ts"
export * from "./commdsClass.vue?vue&type=script&lang=ts"
import style0 from "./commdsClass.vue?vue&type=style&index=0&id=38c8016e&prod&lang=less&scoped=true"
import style1 from "./commdsClass.vue?vue&type=style&index=1&id=38c8016e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8016e",
  null
  
)

export default component.exports